import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Badge from 'src/common/ui-kit/Badge'
import { expiryTimestamps } from './consts'
import CustomDateBadge from './CustomDateBadge'
import Icon from 'src/common/ui-kit/Icon/Icon'

export interface ExpiryBadgesProps {
  expiryTimestamp: number
  onSelect: (value: number) => void
  className?: string
  forceMobileView?: boolean
}

const ExpiryBadges: React.FC<ExpiryBadgesProps> = ({
  expiryTimestamp,
  onSelect,
  className,
  forceMobileView,
}) => {
  const { t } = useTranslation('common')

  const isCustomActive = !expiryTimestamps.find(
    ([, value]) => value === expiryTimestamp
  )

  return (
    <div
      className={clsx(
        'flex gap-2 items-center justify-end flex-wrap',
        className
      )}
    >
      <CustomDateBadge
        className='flex'
        isActive={isCustomActive}
        expiryTimestamp={expiryTimestamp}
        onSelect={onSelect}
        forceMobileView={forceMobileView}
      >
        <>
          <div>{t('expireBades.custom')}</div>
          <Icon className='ml-1' name='arrow-down' size={12} />
        </>
      </CustomDateBadge>
      {expiryTimestamps.map(([text, value]) => (
        <Badge
          key={text}
          color={'secondary'}
          active={value === expiryTimestamp}
          size='sm'
          onClick={() => onSelect(value)}
        >
          {t(`expireBades.${text}`, text)}
        </Badge>
      ))}
    </div>
  )
}

export default ExpiryBadges
